import { Host, h } from '@stencil/core';
export class AibaQuizOption {
  constructor() {
    this.type = undefined;
    this.selectedOptions = undefined;
    this.options = undefined;
    this.optionsEventData = undefined;
    this.variant = undefined;
    this.maxSelection = undefined;
    this.clickEvent = undefined;
    this.handlers = undefined;
    this.optionClasses = undefined;
    this.styles = undefined;
    this.questionId = undefined;
    this.placeholder = undefined;
    this.data = undefined;
    this.hideNextButton = 'none';
    this.loading = undefined;
    this.rerender = false;
    this.renderOptionsOnConsumer = false;
    this.textboxGroupSelectedOptions = {
      firstName: null,
      lastName: null,
    };
    this.errorsUserName = {
      firstName: null,
      lastName: null,
    };
  }
  enableError(event) {
    let detail = (event === null || event === void 0 ? void 0 : event.detail) ? event === null || event === void 0 ? void 0 : event.detail : true;
    if (detail.firstName) {
      this.errorsUserName.firstName = detail.firstName ? detail.firstName : true;
    }
    if (detail.lastName) {
      this.errorsUserName.lastName = detail.lastName ? detail.lastName : true;
    }
    this.errorsUserName = JSON.parse(JSON.stringify(this.errorsUserName));
  }
  async componentDidLoad() {
    if (this.handlers && this.handlers.getOptionsConfig) {
      const { renderOptionsOnConsumer } = await this.handlers.getOptionsConfig();
      this.renderOptionsOnConsumer = renderOptionsOnConsumer;
    }
  }
  handleOptionSelected(option) {
    var _a, _b, _c, _d;
    if (this.type === 'single' && option) {
      this.selectedOptions = [option];
      (this.hideNextButton === 'showOnFirstQuestion' || this.hideNextButton === 'hideTillAnswerSelected') &&
        this.singleOptionSelected.emit({ hideNextButton: this.hideNextButton, optionValue: option });
    }
    else if (this.type === 'multiple' && option) {
      const index = (_a = this.selectedOptions) === null || _a === void 0 ? void 0 : _a.indexOf(option);
      if (index > -1) {
        (_b = this.selectedOptions) === null || _b === void 0 ? void 0 : _b.splice(index, 1);
      }
      else {
        if (((_c = this.selectedOptions) === null || _c === void 0 ? void 0 : _c.length) < this.maxSelection)
          (_d = this.selectedOptions) === null || _d === void 0 ? void 0 : _d.push(option);
      }
    }
    if (this.handlers && this.handlers.handleQuizOptionSelected) {
      this.handlers.handleQuizOptionSelected([...this.selectedOptions], this.questionId);
    }
    this.rerender = !this.rerender;
  }
  handleKeyDown(event) {
    if (event.key === 'Enter') {
      const { target } = event;
      if (target) {
        const selectedValue = target === null || target === void 0 ? void 0 : target.getAttribute('data-answerid');
        if (selectedValue)
          this.handleOptionSelected(selectedValue);
      }
    }
  }
  async handleTextboxOnchange(event) {
    var _a, _b, _c;
    this.selectedOptions = [(_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value];
    if (this.handlers && this.handlers.handleValidationUserPIName) {
      await this.handlers.handleValidationUserPIName((_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value, (_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.name);
    }
    if (this.handlers.handleQuizOptionSelected) {
      await this.handlers.handleQuizOptionSelected([...this.selectedOptions], this.questionId, event);
    }
  }
  async handleOnchange(e) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (this.variant === 'textbox-group') {
      if (((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.name) === 'firstName') {
        this.textboxGroupSelectedOptions.firstName = (_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.value;
        this.selectedOptions = [];
      }
      else if (((_c = e === null || e === void 0 ? void 0 : e.target) === null || _c === void 0 ? void 0 : _c.name) === 'lastName') {
        this.textboxGroupSelectedOptions.lastName = (_d = e === null || e === void 0 ? void 0 : e.target) === null || _d === void 0 ? void 0 : _d.value;
      }
      this.selectedOptions = [this.textboxGroupSelectedOptions];
    }
    else {
      this.selectedOptions = [(_e = e === null || e === void 0 ? void 0 : e.target) === null || _e === void 0 ? void 0 : _e.value];
    }
    if (this.handlers && this.handlers.handleValidationUserPIName) {
      if (this.handlers.handleQuizOptionSelected) {
        this.handlers.handleQuizOptionSelected([...this.selectedOptions], this.questionId);
      }
      await this.handlers.handleValidationUserPIName((_f = e === null || e === void 0 ? void 0 : e.target) === null || _f === void 0 ? void 0 : _f.value, (_g = e === null || e === void 0 ? void 0 : e.target) === null || _g === void 0 ? void 0 : _g.name);
    }
  }
  async handleOnChangeWeather(place) {
    if (!place.geometry) {
      console.log('@AIBA[AibaQuizOption]: No details available for input:  ' + place.name + '');
      return;
    }
    // Get the latitude and longitude
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    const placeName = place.name;
    this.selectedOptions = [`${placeName}:${lat},${lng}`];
    if (this.handlers.handleQuizOptionSelected) {
      this.handlers.handleQuizOptionSelected([...this.selectedOptions], this.questionId);
    }
  }
  getWeatherValue() {
    var _a;
    if (((_a = this.selectedOptions) === null || _a === void 0 ? void 0 : _a.length) > 0) {
      const data = this.selectedOptions[0] ? this.selectedOptions[0] : '';
      return data;
    }
    else {
      return '';
    }
  }
  isSelected(answerId) {
    var _a;
    return ((_a = this.selectedOptions) === null || _a === void 0 ? void 0 : _a.includes(answerId)) ? 'active' : '';
  }
  getValue(name) {
    var _a, _b;
    if (this.variant === 'textbox-group') {
      if (((_a = this.selectedOptions) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        const data = this.selectedOptions[0] ? this.selectedOptions[0] : '';
        if (name === 'firstName') {
          return data.firstName;
        }
        else if (name === 'lastName') {
          return data.lastName;
        }
        return data;
      }
      else {
        return '';
      }
    }
    else {
      if (((_b = this.selectedOptions) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        const data = this.selectedOptions[0] ? this.selectedOptions[0] : '';
        return data;
      }
    }
    return '';
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (typeof this.options === 'string') {
      if (this.options)
        this.options = JSON.parse(this.options);
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: `grid-option-wrapper ${this.variant ? this.variant : ''}` }, this.variant === 'option-with-subques' && (h("div", null, h("option-variation-with-subquestions", { selectedOptions: this.selectedOptions, isPopulated: ((_a = this.selectedOptions) === null || _a === void 0 ? void 0 : _a.length) === this.maxSelection, handlers: this.handlers, data: this.options, onChange: e => this.handleOnchange && this.handleOnchange(e) }))), this.variant === 'textbox' ? (h("div", { class: this.optionClasses ? this.optionClasses : 'quiz-input-container' }, h("aiba-input", Object.assign({}, this.data, { classes: "quiz-input", name: "name", value: this.getValue(), placeholder: ((_b = this.placeholder) === null || _b === void 0 ? void 0 : _b.length) ? this.placeholder : 'Name', onChange: e => this.handleOnchange && this.handleOnchange(e) })))) : ((_c = this.options) === null || _c === void 0 ? void 0 : _c.map((option) => {
      var _a, _b, _c, _d;
      return (h("div", { class: `icon ${this.variant}` }, this.variant === 'iconWithText' && (h("div", { tabIndex: 0, role: "button", "aria-label": option === null || option === void 0 ? void 0 : option.answerText, "data-answerId": option === null || option === void 0 ? void 0 : option.answerId, key: option === null || option === void 0 ? void 0 : option.answerId, class: `option-icon-with-text-wrapper ${this.isSelected(option === null || option === void 0 ? void 0 : option.answerId)}`, onClick: () => this.handleOptionSelected && this.handleOptionSelected(option.answerId) }, !this.renderOptionsOnConsumer && this.isSelected(option === null || option === void 0 ? void 0 : option.answerId) === 'active' && (h("div", { class: `option-icon-with-text-wrapper__icon ${this.isSelected(option === null || option === void 0 ? void 0 : option.answerId)}` }, h("img", { src: ((_a = option === null || option === void 0 ? void 0 : option.activeAsset) === null || _a === void 0 ? void 0 : _a.path) ? (_b = option === null || option === void 0 ? void 0 : option.activeAsset) === null || _b === void 0 ? void 0 : _b.path : (_c = option === null || option === void 0 ? void 0 : option.asset) === null || _c === void 0 ? void 0 : _c.path, alt: "image",
        // eslint-disable-next-line
        //@ts-ignore
        fetchpriority: "high" }))), !this.renderOptionsOnConsumer && this.isSelected(option === null || option === void 0 ? void 0 : option.answerId) !== 'active' && (h("div", { class: `option-icon-with-text-wrapper__icon ${this.isSelected(option === null || option === void 0 ? void 0 : option.answerId)}` }, h("img", { src: (_d = option === null || option === void 0 ? void 0 : option.asset) === null || _d === void 0 ? void 0 : _d.path, alt: "image",
        // eslint-disable-next-line
        //@ts-ignore
        fetchpriority: "high" }))), this.renderOptionsOnConsumer && h("div", { class: `option-icon-with-text-wrapper__icon answer-id-${option === null || option === void 0 ? void 0 : option.answerId} ${this.isSelected(option === null || option === void 0 ? void 0 : option.answerId)}` }), h("div", { class: "option-wrapper__option-title" }, option === null || option === void 0 ? void 0 : option.answerText))), this.variant === 'text' && (h("div", { tabIndex: 0, role: "button", "aria-label": option === null || option === void 0 ? void 0 : option.answerText, "data-answerId": option === null || option === void 0 ? void 0 : option.answerId, key: option === null || option === void 0 ? void 0 : option.answerId, class: `option-only-text-wrapper ${this.isSelected(option === null || option === void 0 ? void 0 : option.answerId)}`, onClick: () => this.handleOptionSelected && this.handleOptionSelected(option === null || option === void 0 ? void 0 : option.answerId), onMouseDown: this.optionsEventData && this.optionsEventData['mousedown'] ? () => this.handleOptionSelected && this.handleOptionSelected(option === null || option === void 0 ? void 0 : option.answerId) : null, onTouchStart: this.optionsEventData && this.optionsEventData['touchstart'] ? () => this.handleOptionSelected && this.handleOptionSelected(option === null || option === void 0 ? void 0 : option.answerId) : null }, h("div", { class: "option-wrapper__option-title" }, option === null || option === void 0 ? void 0 : option.answerText), ' ')), this.variant === 'checkbox' && (h("div", { tabIndex: 0, "aria-label": option === null || option === void 0 ? void 0 : option.answerText, role: "button", "data-answerId": option === null || option === void 0 ? void 0 : option.answerId, key: option === null || option === void 0 ? void 0 : option.answerId, class: `option-wrapper-checkbox ${this.isSelected(option === null || option === void 0 ? void 0 : option.answerId)}` }, h("input", { type: `checkbox`, onClick: () => this.handleOptionSelected && this.handleOptionSelected(option === null || option === void 0 ? void 0 : option.answerId) }), " ", option === null || option === void 0 ? void 0 :
        option.answerText, ' ')), this.variant === 'textbox-group' && (h("div", { class: this.optionClasses ? this.optionClasses : 'quiz-input-container' }, h("aiba-input", Object.assign({}, option.data, { classes: "quiz-input", value: this.getValue(option.data.name), error: this.errorsUserName[option.data.name], onChange: e => this.handleOnchange && this.handleOnchange(e), onFocusout: e => this.handleOnchange && this.handleOnchange(e) })))), this.variant === 'textWithTickBox' && (h("div", { tabIndex: 0, role: "button", "aria-label": option === null || option === void 0 ? void 0 : option.answerText, "data-answerId": option === null || option === void 0 ? void 0 : option.answerId, key: option === null || option === void 0 ? void 0 : option.answerId, class: `option-only-text-wrapper ${this.isSelected(option === null || option === void 0 ? void 0 : option.answerId)}`, onClick: () => this.handleOptionSelected && this.handleOptionSelected(option === null || option === void 0 ? void 0 : option.answerId) }, h("div", { class: "option-wrapper__option-tickbox " }), h("div", { class: "option-wrapper__option-title " }, option === null || option === void 0 ? void 0 : option.answerText)))));
    })), this.variant === 'textbox-transition' && (h("div", { class: this.optionClasses ? this.optionClasses : 'quiz-input-container' }, h("aiba-input", Object.assign({}, this.data, { classes: "quiz-input", value: this.getValue(), onChange: ((_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d['events']) === null || _e === void 0 ? void 0 : _e['change']) ? e => this === null || this === void 0 ? void 0 : this.handleTextboxOnchange(e) : null, onClick: ((_g = (_f = this.data) === null || _f === void 0 ? void 0 : _f['events']) === null || _g === void 0 ? void 0 : _g['click']) ? e => this === null || this === void 0 ? void 0 : this.handleTextboxOnchange(e) : null, onKeyUp: ((_j = (_h = this.data) === null || _h === void 0 ? void 0 : _h['events']) === null || _j === void 0 ? void 0 : _j['keyup']) ? e => this === null || this === void 0 ? void 0 : this.handleTextboxOnchange(e) : null, onBlur: ((_l = (_k = this.data) === null || _k === void 0 ? void 0 : _k['events']) === null || _l === void 0 ? void 0 : _l['blur']) ? e => this === null || this === void 0 ? void 0 : this.handleTextboxOnchange(e) : null })))), this.variant === 'weatherDropdown' && (h("aiba-weather-dropdown", { data: this.data, handlers: this.handlers, onChangeHandler: e => this.handleOnChangeWeather(e), value: this.getWeatherValue(), loading: this.loading })))));
  }
  static get is() { return "aiba-quiz-option"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-quiz-option.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-quiz-option.css"]
    };
  }
  static get properties() {
    return {
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'single' | 'multiple'",
          "resolved": "\"multiple\" | \"single\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "type",
        "reflect": false
      },
      "selectedOptions": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "any[]",
          "resolved": "any[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "options": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "options",
        "reflect": false
      },
      "optionsEventData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "options-event-data",
        "reflect": false
      },
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "| 'icon'\n    | 'iconWithText'\n    | 'text'\n    | 'checkbox'\n    | 'textbox'\n    | 'textbox-group'\n    | 'textWithTickBox'\n    | 'weatherDropdown'\n    | 'option-with-subques'\n    | 'textbox-transition'",
          "resolved": "\"checkbox\" | \"icon\" | \"iconWithText\" | \"option-with-subques\" | \"text\" | \"textWithTickBox\" | \"textbox\" | \"textbox-group\" | \"textbox-transition\" | \"weatherDropdown\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": false
      },
      "maxSelection": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "max-selection",
        "reflect": false
      },
      "clickEvent": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "click-event",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "optionClasses": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "option-classes",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "questionId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "question-id",
        "reflect": false
      },
      "placeholder": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "placeholder",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "hideNextButton": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'showOnFirstQuestion' | 'hideTillAnswerSelected' | 'none'",
          "resolved": "\"hideTillAnswerSelected\" | \"none\" | \"showOnFirstQuestion\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "hide-next-button",
        "reflect": false,
        "defaultValue": "'none'"
      },
      "loading": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "loading",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "rerender": {},
      "renderOptionsOnConsumer": {},
      "textboxGroupSelectedOptions": {},
      "errorsUserName": {}
    };
  }
  static get events() {
    return [{
        "method": "selected",
        "name": "selected",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "string[]",
          "resolved": "string[]",
          "references": {}
        }
      }, {
        "method": "singleOptionSelected",
        "name": "singleOptionSelected",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get listeners() {
    return [{
        "name": "event-userPI-error",
        "method": "enableError",
        "target": "window",
        "capture": true,
        "passive": false
      }, {
        "name": "keydown",
        "method": "handleKeyDown",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-quiz-option.js.map
